import { CardHeader } from './CardHeader';
import { Shimmer } from '../Shimmer/Shimmer';
import styles from './CardHeaderSkeleton.module.css';

/**
 * The loading state of {@link CardHeader} — the real header with shimmer blocks
 * in place of its icon, title and meta. Lives beside CardHeader so the two stay
 * the same shape: a skeleton that drifts from its component reflows on load,
 * which is exactly what a skeleton exists to prevent.
 */
export function CardHeaderSkeleton({ size }: { size?: 'sm' | 'md' }) {
  return (
    <CardHeader
      size={size}
      icon={<Shimmer className={styles.icon} />}
      title={<Shimmer className={styles.title} />}
      meta={<Shimmer className={styles.meta} />}
    />
  );
}
